<script setup>
import { ref, nextTick } from "vue";
import { StealieFileUpload } from "@get-overalls/fe-stealie";
import { getUploadData } from "@/services/RequestService";

const emit = defineEmits(["file-selected", "upload-success"]);
const url = ref();
const uploadKey = ref();

const fileUploadRef = ref(null);
const uploadFile = async () => {
  try {
    const { presignedUrl, key } = await getUploadData(fileUploadRef.value.files[0].name);
    uploadKey.value = key;
    url.value = presignedUrl;
    await nextTick();
    fileUploadRef.value.upload();
    return uploadKey.value;
  } catch (error) {
    console.error(error);
  }
};
defineExpose({
  uploadFile,
  uploadRef: fileUploadRef,
});

const handleUploadSuccess = ({ file }) => {
  emit("upload-success", file);
};
</script>

<template>
  <StealieFileUpload
    ref="fileUploadRef"
    :url="url"
    accept="image/*,application/pdf"
    invalid-file-type-message="'{0}' has an invalid file type. Only images or PDFs are allowed."
    data-sr-mask
    @upload-success="handleUploadSuccess"
  />
</template>
